import { render, staticRenderFns } from "./PetsClaimVet.vue?vue&type=template&id=7a00dabe&"
import script from "./PetsClaimVet.vue?vue&type=script&lang=js&"
export * from "./PetsClaimVet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports